import { c as _c } from "react/compiler-runtime";
import { FormInput, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { duplicateFunnel } from 'modules/funnels/api/funnels-api';
import { FunnelDuplicateInterface, FunnelInterface } from 'modules/funnels/types/funnel-interface';
import React, { useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
interface FunnelDuplicateModalProps {
  opened: boolean;
  onClose: () => void;
  funnel: FunnelInterface;
  onUpdateData: () => Promise<void>;
}
const defaultErrors = {
  name: '',
  common: ''
};
const FunnelDuplicateModal = t0 => {
  const $ = _c(38);
  const {
    opened,
    onClose,
    funnel,
    onUpdateData
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [name, setName] = useState(`${funnel.name} (copy)`);
  const [isFetching, setIsFetching] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] !== onUpdateData || $[1] !== t) {
    t1 = async (funnel_0, data) => {
      ;
      try {
        setIsFetching(true);
        await fetchWithErrors(async () => {
          await duplicateFunnel(funnel_0.id, data);
          await onUpdateData();
          toast.success(t("global.duplicated"));
          setIsFetching(false);
        }, setErrors);
      } catch (t2) {
        const e = t2;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          if (e.errors.common) {
            const commonError = e.errors.common.join("");
            setErrors(prev => ({
              ...prev,
              common: commonError
            }));
          }
        } else {
          if (e instanceof InternalError) {
            setErrors(t("core.error.internal_error_message"));
          } else {
            toast.error(t("global.error"));
          }
        }
      }
    };
    $[0] = onUpdateData;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onDuplicateFunnel = t1;
  let t2;
  if ($[3] !== funnel.name) {
    t2 = () => {
      setName(`${funnel.name} (copy)`);
      setErrors(defaultErrors);
    };
    $[3] = funnel.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.funnel.duplicate_funnel");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.funnel.name_of_duplicate_funnel");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e_0 => setName(e_0.target.value);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== errors.name || $[11] !== name || $[12] !== t4) {
    t6 = <div className="flex flex-col justify-center gap-3"><FormInput value={name} label={t4} onChange={t5} error={errors.name} /></div>;
    $[10] = errors.name;
    $[11] = name;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = name === "";
  let t8;
  if ($[14] !== funnel || $[15] !== name || $[16] !== onDuplicateFunnel) {
    t8 = async e_1 => {
      e_1.preventDefault();
      await onDuplicateFunnel(funnel, {
        name
      });
    };
    $[14] = funnel;
    $[15] = name;
    $[16] = onDuplicateFunnel;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("global.duplicate");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isFetching || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="flex justify-center gap-4"><PrimaryButton isFetching={isFetching} disabled={t7} onClick={t8}>{t9}</PrimaryButton></div>;
    $[20] = isFetching;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== errors.common) {
    t11 = errors.common && <FieldErrorAndDescription error={errors.common} errorClassName="text-center" />;
    $[25] = errors.common;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t6) {
    t12 = <form className="flex flex-col gap-6 lg:gap-10">{t6}{t10}{t11}</form>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t6;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== isFetching || $[32] !== onClose || $[33] !== opened || $[34] !== t12 || $[35] !== t2 || $[36] !== t3) {
    t13 = <Modal isFetching={isFetching} opened={opened} onClose={onClose} afterLeave={t2} title={t3}>{t12}</Modal>;
    $[31] = isFetching;
    $[32] = onClose;
    $[33] = opened;
    $[34] = t12;
    $[35] = t2;
    $[36] = t3;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
export default FunnelDuplicateModal;